let language = {
    BULK_ORDER_LIST_HEADER_PRODUCT: "产品",
    BULK_ORDER_LIST_HEADER_STORE_ORDER: "商店/订单号",
    BULK_ORDER_LIST_HEADER_SITE_PRICE: "价格",

    // 
    BULK_ORDER_LIST_SUMMARY_HEADER: "拼单汇总:",
    BULK_ORDER_LIST_SUMMARY_SUBTOTAL_CONTENT: "小计:",
    BULK_ORDER_LIST_SUMMARY_TOTAL_CONTENT: "总计:",
    
    BULK_ORDER_LIST_COMBINE_ORDER_TITLE: "拼单",

    // 
    BULK_ORDER_LIST_PREBULK_ORDER_ITEM: "预处理订单项",
    
    BULK_ORDER_LIST_BULK_ALL_TEXT: "一键拼单",

    //
    BULK_ORDER_LIST_CHECKOUT_BTN: "结账",
    BULK_ORDER_LIST_ALL_SELECT_CHECKBOX: "全选",

    BULK_ORDER_LIST_DISABLE_REASONS: "禁止原因:"
};

export { language }
